<div *ngIf="!isDescriptorsPropagationView && !isPreview">
	<div class="modal-body">
		<form name="form" #f="ngForm" class="form-horizontal" >
			<!-- Breeding method selection -->
			<h4 jhiTranslate="advance-study.breeding-methods.title"></h4>
			<div class="mb-3 row">
				<div class="col-sm-6">
					<div class="form-check form-check-inline">
						<input type="checkbox" class="form-check-input" name="breedingMethodCheck" id="breedingMethodCheck" (click)="onSelectMethodVariable($event)" [(ngModel)]="breedingMethodCheck">
						<label class="form-check-label fw-bold" for="breedingMethodCheck" jhiTranslate="advance-study.breeding-methods.description">Breeding Method is the same for each advance</label>
					</div>
				</div>
				<div class="col-sm-6">
					<jhi-breeding-methods-select [(value)]="breedingMethodSelectedId"
												 [useFavoriteBreedingMethods]="true"
												 [disabled]="showBreedingMethodVariableSelection"
												 [disableMethodTypeFilterSection]="true"
												 [helpLink]="helpLink"
												 [selectWidth]="'90%'"
												 (onMethodChanged)="onMethodChange($event)"></jhi-breeding-methods-select>
				</div>
			</div>
			<div *ngIf="showBreedingMethodVariableSelection" class="mb-3 row">
				<div class="col-sm-6">
					<label for="breedingMethod" class="form-check-label fw-bold" jhiTranslate="advance-study.breeding-methods.variable">Choose a variate that defines the breeding method for each advance</label>
				</div>
				<div class="col-sm-6">
					<select class="form-select" name="breedingMethodVariable" id="breedingMethodVariable" [(ngModel)]="breedingMethodSelectedVariableId">
						<option *ngFor="let variable of selectionMethodVariables" [value]="variable.termId">
							<label>{{variable.name}}</label>
						</option>
					</select>
				</div>
			</div>

			<!-- Selection Trait -->
			<div *ngIf="showSelectionTraitSelection">
				<h4 jhiTranslate="advance-study.selection-trait.title">Selection Trait</h4>
				<p for="selectionTraitLevel" class="form-check-label fw-bold" jhiTranslate="advance-study.selection-trait.description"></p>
				<div class="col-sm-12">
					<div class="mb-3 row">
						<div class="col-sm-6">
							<label for="selectionTraitLevel" class="form-check-label fw-bold" jhiTranslate="advance-study.selection-trait.level">Level</label>
							<select class="form-select" name="selectionTraitLevel" id="selectionTraitLevel" [(ngModel)]="selectedSelectionTraitDatasetId" (ngModelChange)="onSelectionTraitLevelChanged($event)">
								<option *ngFor="let level of selectionTraitLevelOptions" [hidden]="!level.show" [value]="level.value">
									<label>{{level.label}}</label>
								</option>
							</select>
						</div>
						<div class="col-sm-6">
							<label for="selectionTraitLevel" class="form-check-label fw-bold" jhiTranslate="advance-study.selection-trait.variables">Variables</label>
							<select class="form-select" name="selectionTraitVariables" id="selectionTraitVariables" [(ngModel)]="selectedSelectionTraitVariableId" [disabled]="selectionTraitVariables.length === 0">
								<option *ngFor="let variable of selectionTraitVariables" [value]="variable.termId">
									<label>{{variable.name}}</label>
								</option>
							</select>
						</div>
					</div>
				</div>
			</div>

			<!-- Line selection -->
			<div *ngIf="showBreedingMethodVariableSelection || showLinesSelection">
				<h4 jhiTranslate="advance-study.lines.title"></h4>
				<div class="col-sm-12 form-check form-check-inline">
					<input type="checkbox" class="form-check-input" name="linesCheck" id="linesCheck" (click)="onSelectLineVariable($event)" [(ngModel)]="linesCheck">
					<label for="linesCheck"  class="form-check-label fw-bold" jhiTranslate="advance-study.lines.description">Same number of lines is selected for each plot</label>
				</div>
				<div *ngIf="linesCheck">
					<div class="mt-2 mb-3 row">
						<div class="col-sm-6">
							<label class="form-check-label fw-bold" for="linesNumber" id="linesNumber" jhiTranslate="advance-study.lines.lines-number">Lines Selected per Plot:</label>
						</div>
						<div class="col-sm-6">
							<input type="number" class="ms-0 form-control" name="linesNumber" [(ngModel)]="selectedLinesNumber">
						</div>
					</div>
				</div>
				<div *ngIf="!linesCheck" class="mt-2 mb-3 row">
					<div class="col-sm-6">
						<label class="form-check-label fw-bold" for="breedingMethod" jhiTranslate="advance-study.lines.variable">Choose a variate that defines the breeding method for each advance</label>
					</div>
					<div class="col-sm-6">
						<select class="form-select" name="lineSelectionVariable" id="lineSelectionVariable" [(ngModel)]="selectedLinesVariableId">
							<option *ngFor="let variable of selectionPlantVariables" [value]="variable.termId">
								<label>{{variable.name}}</label>
							</option>
						</select>
					</div>
				</div>
			</div>

			<!-- Bulking selection -->
			<div *ngIf="showBulkingSelection">
				<h4 jhiTranslate="advance-study.bulks.title"></h4>
                <div class="mb-3">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" name="bulksCheck" id="bulksCheck" (click)="onSelectPlotVariable($event)" [(ngModel)]="bulksCheck">
                        <label class="form-check-label fw-bold" for="bulksCheck" jhiTranslate="advance-study.bulks.description">All plots are selected</label>
                    </div>
                    <div *ngIf="!bulksCheck" class="row mt-2">
                        <div class="col-sm-6">
                            <label class="form-check-label fw-bold" for="breedingMethod" jhiTranslate="advance-study.bulks.variable">Choose a variate that defines which plots were selected</label>
                        </div>
                        <div class="col-sm-6">
                            <select class="form-select" name="lineSelectionBulkingVariable" id="lineSelectionBulkingVariable" [(ngModel)]="selectedPlotVariableId">
                                <option *ngFor="let variable of selectionPlantVariables" [value]="variable.termId">
                                    <span>{{variable.name}}</span>
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
			</div>

			<!-- Repetition selection -->
			<div *ngIf="replicationsOptions.length > 0">
				<h4 jhiTranslate="advance-study.reps.title"></h4>
				<div class="mb-3">
                    @for (rep of replicationsOptions; track rep.index) {
                        <input class="btn-check" type="checkbox" [(ngModel)]="rep.selected" (click)="toggleCheck(rep.selected)"
                               name="check-{{rep.index}}" id="check-{{rep.index}}">
                        <label class="btn btn-outline-success fw-bold mt-1 me-2" for="check-{{rep.index}}">
                            @if (rep.selected) {
                                <i class="fa fa-check me-1"></i>
                            }
                            {{rep.index}}
                        </label>
                    }
					<div class="form-check form-check-inline">
						<input type="checkbox" class="form-check-input" [(ngModel)]="checkAllReplications" (click)="toggleAll()" name="selectAllReps" id="selectAllReps"/>
						<label class="form-check-label" for="selectAllReps" jhiTranslate="advance-study.reps.select.all">Select All</label>
					</div>
				</div>
			</div>

			<!-- Location Details -->
			<h4 jhiTranslate="advance-study.location.title"></h4>
			<div class="col-xs-12 col-md-12 mt-3">
                <table class="table table-striped table-bordered table-curved">
                    <thead>
                    <tr>
                    <th><span jhiTranslate="advance-study.location.trial.instance">TRIAL_INSTANCE</span></th>
                    <th><span jhiTranslate="advance-study.location.name">LOCATION_NAME</span></th>
                    </tr>
                    </thead>
                    <tbody this.trialInstances>
                    <tr *ngFor="let trialInstance of trialInstances">
                        <td>{{trialInstance.instanceNumber}}</td>
                        <td>{{trialInstance.locAbbr}}</td>
                    </tr>
                    </tbody>
                </table>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="showPropagateDescriptorsView()">
			<span jhiTranslate="entity.action.back">Back</span>
		</button>
		<button (click)="preview(true)" [disabled]="!isValid() || isLoading" class="btn btn-primary" data-test="advanceStudyPreviewButton">
			<span *ngIf="isLoadingPreview" class="throbber throbber-btn"></span>
			<span jhiTranslate="advance.preview">Preview</span>
		</button>
		<button (click)="save()" [disabled]="!isValid() || isLoading" class="btn btn-primary" data-test="advanceStudyButton">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span jhiTranslate="advance.action">Advance</span>
		</button>
	</div>
</div>
<div *ngIf="!isDescriptorsPropagationView && isPreview" >
	<div class="modal-body">
		<jhi-collapsible heading="{{translateService.instant('advance-preview.summary.title')}}">
			<div class="table-responsive p-2">
				<table class="table table-striped table-bordered table-curved table-fixed" style="width: 40%">
					<thead>
                    <tr>
						<th></th>
						<th><span jhiTranslate="advance-preview.summary.column">#</span></th>
                    </tr>
					</thead>
					<tbody>
						<tr>
							<td><span jhiTranslate="advance-preview.summary.count.environment"></span></td>
							<td>{{selectedInstances.length}}</td>
						</tr>
						<tr>
							<td><span jhiTranslate="advance-preview.summary.count.reps"></span></td>
							<td>{{getReplicationNumber()}}</td>
						</tr>
						<tr>
							<td><span jhiTranslate="advance-preview.summary.count.plots"></span></td>
							<td>{{originalTotalItems}}</td>
						</tr>
						<tr *ngIf="isPlantDataset()">
							<td><span jhiTranslate="advance-preview.summary.count.plants"></span></td>
							<td>{{originalTotalItems}}</td>
						</tr>
						<tr>
							<td><span jhiTranslate="advance-preview.summary.count.germplasm"></span></td>
							<td>{{originalTotalItems}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</jhi-collapsible>
		<jhi-collapsible heading="{{translateService.instant('advance-preview.data.title')}}">
            <div class="p-2">
                <div class="table-responsive" *ngIf="currentPagePreviewList" style="max-height: 500px;">
                    <table id="advance-preview-table " class="table table-striped table-bordered table-curved">
                        <thead>
                        <tr>
                            <th scope="col">
                                <span jhiTranslate="advance-preview.data.columns.entryNumber"></span>
                                <jhi-column-filter-inline [filter]="filters.entryNumber"
                                                          (onApply)="applyFilters()"
                                                          (onReset)="applyFilters()">
                                </jhi-column-filter-inline>
                            </th>
                            <th scope="col" >
                                <span jhiTranslate="advance-preview.data.columns.designation"></span>
                            </th>
                            <th scope="col">
                                <span jhiTranslate="advance-preview.data.columns.cross"></span>
                                <jhi-column-filter-inline [filter]="filters.cross"
                                                          (onApply)="applyFilters()"
                                                          (onReset)="applyFilters()">
                                </jhi-column-filter-inline>
                            </th>
                            <th scope="col" >
                                <span jhiTranslate="advance-preview.data.columns.gid"></span>
                            </th>
                            <th scope="col" >
                                <span jhiTranslate="advance-preview.data.columns.immediateSource"></span>
                                <jhi-column-filter-inline [filter]="filters.immediateSource"
                                                          (onApply)="applyFilters()"
                                                          (onReset)="applyFilters()">
                                </jhi-column-filter-inline>
                            </th>
                            <th scope="col">
                                <span jhiTranslate="advance-preview.data.columns.breedingMethod"></span>
                                <jhi-column-filter-inline [filter]="filters.breedingMethod"
                                                          (onApply)="applyFilters()"
                                                          (onReset)="applyFilters()">
                                </jhi-column-filter-inline>
                            </th>
                            <th scope="col" >
                                <span jhiTranslate="advance-preview.data.columns.environment"></span>
                                <jhi-column-filter-inline [filter]="filters.environment"
                                                          (onApply)="applyFilters()"
                                                          (onReset)="applyFilters()">
                                </jhi-column-filter-inline>
                            </th>
                            <th  scope="col">
                                <span jhiTranslate="advance-preview.data.columns.plotNumber"></span>
                                <jhi-column-filter-inline [filter]="filters.plotNumber"
                                                          (onApply)="applyFilters()"
                                                          (onReset)="applyFilters()">
                                </jhi-column-filter-inline>
                            </th>
                            <th  *ngIf="isPlantDataset()" scope="col" >
                                <span jhiTranslate="advance-preview.data.columns.plantNumber"></span>
                                <jhi-column-filter-inline [filter]="filters.plantNumber"
                                                          (onApply)="applyFilters()"
                                                          (onReset)="applyFilters()">
                                </jhi-column-filter-inline>
                            </th>
                        </tr>
                        </thead>
                        <tbody *ngIf="currentPagePreviewList.length else nodata">
                        <tr *ngFor="let advancedGermplasm of currentPagePreviewList">
                            <td>{{advancedGermplasm.entryNumber}}</td>
                            <td><truncate-span [textInput]="advancedGermplasm.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
                            <td><truncate-span [textInput]="advancedGermplasm.cross" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
                            <td jhiTranslate="advance-preview.data.pending"></td>
                            <td><truncate-span [textInput]="advancedGermplasm.immediateSource" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
                            <td>{{advancedGermplasm.breedingMethodAbbr}}</td>
                            <td>{{advancedGermplasm.trialInstance + "-" + advancedGermplasm.locationName}}</td>
                            <td>{{advancedGermplasm.plotNumber}}</td>
                            <td *ngIf="isPlantDataset()">{{advancedGermplasm.plantNumber}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <ng-template #nodata>
                        <tbody>
                        <tr>
                            <td colspan="8" jhiTranslate="no.data"></td>
                        </tr>
                        </tbody>
                    </ng-template>
                </div>
            </div>
			<div *ngIf="currentPagePreviewList && currentPagePreviewList.length">
				<div class="row">
					<div class="col">
						<div class="pagination-container">
							<div class="pagination-box pagination-box-left">
								<div>
									<jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
								</div>
							</div>
							<div class="pagination-box">
								<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
												[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
							</div>
							<div class="pagination-box pagination-box-right">
								<div class="d-flex align-items-center">
									<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
									<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading"
											(change)="resetTable();preview(true);" style="width:95px">
										<option value="10">10</option>
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="75">75</option>
										<option value="100">100</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</jhi-collapsible>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="exitPreview()">
			<span jhiTranslate="entity.action.back">Back</span>
		</button>
		<button (click)="save()" [disabled]="!isValid() || isLoading" class="btn btn-primary" data-test="advanceStudyButton">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span jhiTranslate="advance.action">Advance</span>
		</button>
	</div>
</div>
<jhi-propagate-descriptors [isDescriptorsPropagationView]="isDescriptorsPropagationView" [advanceType]="advanceType" [selectedDatasetId]="selectedDatasetId"></jhi-propagate-descriptors>

